import { IUICfgUIHtmlBlockUIElement } from '@canvas-logic/clp-api-types';
import { ElementState } from '@/elements/base/ElementState';

let nextId = 0;

export class HtmlBlockState extends ElementState {
  readonly elementKind = 'ui-element';
  readonly elementType = 'HTMLBlock';
  public id = 'html-block-view-state-' + ++nextId;

  get html() {
    return this.element.html;
  }

  get viewElement() {
    return this.element;
  }

  constructor(private readonly element: IUICfgUIHtmlBlockUIElement) {
    super();
  }
}
